// slices/userGuideSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { getUserGuideThunk } from "../thunks/userGuideThunks";

const initialState = {
  guides: null,
  loading: false,
  error: null,
};

const userGuideSlice = createSlice({
  name: "userGuide",
  initialState,
  reducers: {
    resetUserGuide: (state) => {
      state.guides = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserGuideThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserGuideThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.guides = action.payload;
      })
      .addCase(getUserGuideThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUserGuide } = userGuideSlice.actions;
export default userGuideSlice.reducer;
